export const BadgeNumber = ({ number }: { number: number }) => {
  return number > 0 ? (
    <div className="rounded-full bg-primary-600 px-2 py-0.5 text-xs font-bold text-white">
      {number}
    </div>
  ) : null
}
